import React, { useEffect, useRef, useState } from 'react'
import '../CreateProduct.css'
import {
  makeStyles,
  Paper,
  Button,
} from '@material-ui/core'
import { useHistory } from 'react-router-dom';
import clsx from 'clsx'
import classNames from 'classnames'
import CustomAlert from '../../CustomAlert'
import CheckUserProvider from '../../../AllHooks/CheckUserProvider'
import { Helmet } from 'react-helmet'
import { createExtraMedicineDocument, getExtraMedicineForSupply } from '../../../Backend/firebase/supply-order'
import { parseMedicineExcelData } from '../../../mock'
import { parseSchemeMedicineExcelData } from '../../../mock/schemes';

const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'initial',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: '100%',
    padding: '20px',
  },
}))

function AddExtraMedicine() {
  const classes = useStyles();
  const history = useHistory()
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight)
  const [openNotify, setOpenNotify] = React.useState(false)
  const [notificationMessage, setNotificationMessage] = useState('')
  const [alertType, setAlertType] = useState('')
  const { userData } = CheckUserProvider()
  const [medicationItems, setMedicationItems] = useState([])
  const [inputValue, setInputValue] = useState('');
  const [medicineType, setMedicineType] = useState('');
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);

  useEffect(async () => {
    try {
      const getExtraMedicine = await getExtraMedicineForSupply()
      const getMedicineList = parseMedicineExcelData();
      const getLocalSchemeMedicineList = parseSchemeMedicineExcelData();
      setMedicationItems([...getExtraMedicine, ...getMedicineList, ...getLocalSchemeMedicineList]);
    } catch (error) {
      console.log('Error Occur in Get Products And Sales', error)
    }
  }, [])

  // Handle input change and filter suggestions
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value) {
      const filtered = medicationItems?.filter((productItem) =>
        productItem?.ProductName.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredSuggestions(filtered);
    } else {
      setFilteredSuggestions([]);
    }
  };

  // Handle suggestion click (only set inputValue, do not add to selected items)
  const handleSuggestionClick = (suggestion) => {
    setInputValue(suggestion?.ProductName);
    setFilteredSuggestions([]);
  };

  const onTapAddProductButton = () => {
    if (inputValue) {
      let item = medicationItems.find(s => s.ProductName.toLowerCase() === inputValue.toLowerCase());
      if (!item) {
        item = {
          _id: medicationItems.length + 1,
          ProductName: inputValue,
        };
        setMedicationItems([...medicationItems, item]);

        //Added Extra Medicine 
        var newMedicine = {};
        newMedicine.userId = userData.uid;
        newMedicine.ProductName = inputValue;
        newMedicine.MedicineType = medicineType;
        try {
          var createdMedicine = createExtraMedicineDocument(newMedicine);
          if (createdMedicine) {
            setNotificationMessage('Extra Medicine Added Successfully');
            setOpenNotify(true);
            setAlertType('success');
          } else {
            setNotificationMessage('Something went wrong, try again later!!');
            setOpenNotify(true);
            setAlertType('error');
          }
        } catch (error) {
          console.error(error);
          setNotificationMessage('Something went wrong, try again later!!');
          setOpenNotify(true);
          setAlertType('error');
        }
      } else {
        setNotificationMessage('Medicine Already available!!');
        setOpenNotify(true);
        setAlertType('error');
      }

      setInputValue('');
      setMedicineType('');
      setFilteredSuggestions([]); // Clear suggestions
    } else {
      setNotificationMessage('Please Enter Medication Name!');
      setOpenNotify(true);
      setAlertType('error');
    }
  }

  return (
    <>
      <div className="createProduct mt-2">
        <Helmet>
          <meta name="description" content="Generate Invoice" />
          <title>Generate Invoice | Kaipsool Pharmatech</title>
        </Helmet>
        <Paper className={fixedHeightPaper}>
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-12 inline-extra-style">
              <h5>Add Extra Medicine</h5>
              <div className="allProducts__productStatusFilter">
                <div className={`allProducts__productStatusContent allProducts__flexContent`}>
                  <Button
                    variant="contained"
                    className={`employerIndex__createPostBtn employerIndex__createProduct`}
                    onClick={() => history.push('/supply/import-extra-medicine')}>Import Extra Medicine From Invoice</Button>
                </div>
              </div>
            </div>
            <div className="generic-tab mt-4">
              <div className="row mb-3 row--col--md--12">
                <div className="col-md-8 mb-2 searchOrAdd">
                  <label>Search or Add Medicine</label>
                  <input
                    type="text"
                    className={classNames(
                      'form-control registerEmp__textbox',
                    )}
                    value={inputValue}
                    onChange={handleInputChange}
                    placeholder="Enter Name of the medicines..."
                  />

                  {/* Popup dropdown styling for suggestions */}
                  {filteredSuggestions.length > 0 && (
                    <ul>
                      {filteredSuggestions.map((suggestion) => (
                        <li
                          key={suggestion._id}
                          onClick={() => handleSuggestionClick(suggestion)}
                          style={{ padding: '8px', cursor: 'pointer', color: '#333', borderBottom: 'solid 1px #000' }}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                        >
                          {suggestion.ProductName}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                <div className="col-md-4 mb-2">
                  Medicine Type
                  <select
                    className={classNames("form-select registerEmp__textbox")}
                    aria-label="Default select example"
                    name="medicineType"
                    onChange={(text) => setMedicineType(text)}
                    defaultValue="Select Medicine Type" >
                    <option value="Select Option">Select Option</option>
                    <option value={'Branded'}>{'Branded'}</option>
                    <option value={'Generic'}>{'Generic'}</option>
                  </select>
                </div>
                <div className="col-md-12 mb-2">
                  <label>{' '}</label>
                  <div className="addExtraBox">
                    <Button
                      onClick={onTapAddProductButton}
                      variant="contained"
                      className="registerEmp__btnLogin jsmAdd"
                    >
                      {'Submit'}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Paper>
      </div>
      <CustomAlert
        setOpenNotify={setOpenNotify}
        openNotify={openNotify}
        messageType={alertType}
        notificationMessage={notificationMessage}
      />
    </>
  )
}

export default AddExtraMedicine
